import React from 'react';
import { filterDisplayableImages } from '../utils/projectImages';
import './ProjectCard.css';

const ProjectCard = ({ project, onClick, imageOnly = false }) => {
  const images = filterDisplayableImages(project.images || (project.image ? [project.image] : []));
  const hasMultipleImages = images.length > 1;
  const mainImage = images[0] || '';

  const hasGallery = images.length > 0;
  const isClickable = hasGallery && onClick;

  if (!mainImage) return null;

  return (
    <div
      onClick={() => isClickable && onClick({ ...project, images })}
      className={`project-card-wrapper ${isClickable ? 'clickable' : ''} ${imageOnly ? 'image-only' : ''}`}
    >
      {/* Image Container */}
      <div className="project-card-image-container">
        {hasMultipleImages && (
          <div className="project-card-image-badge">
            {images.length} Images
          </div>
        )}
        <img
          src={mainImage}
          alt={project.alt || project.name || 'CM Mahal'}
          className="project-card-image"
          onError={(e) => {
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTgiIGZpbGw9IiM5Y2EzYWYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIiBmb250LWZhbWlseT0ic2Fucy1zZXJpZiI+SW1hZ2UgQ29taW5nIFNvb24=';
          }}
        />
        {isClickable && !imageOnly && (
          <div className="project-card-image-overlay">
            <div className="project-card-image-overlay-text">
              {hasMultipleImages ? `Click to view ${images.length} images` : 'Click to view image'}
            </div>
          </div>
        )}
      </div>

      {!imageOnly && project.name && (
        <div className="project-card-content">
          <h3 className="project-card-title">
            {project.name}
          </h3>
        </div>
      )}
    </div>
  );
};

export default ProjectCard;
